<template>
  <div class="metric-card" :style="{ borderTopColor: metric.color }">
    <div class="card-header">
      <h3>{{ label }}</h3>
      <div class="card-badge" :style="{ backgroundColor: metric.color }">
        {{ metric.count }}
      </div>
    </div>

    <div class="card-body">
      <div class="metric-row">
        <span class="label">Total Amount:</span>
        <span class="value">{{ formatCurrency(metric.total) }}</span>
      </div>

      <div class="metric-row">
        <span class="label">Purchases:</span>
        <span class="value">{{ metric.count }}</span>
      </div>
    </div>

    <div class="card-footer">
      <button @click="$emit('view-details')" class="view-btn">
        View Details →
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  metric: {
    type: Object,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

defineEmits(['view-details']);

const formatCurrency = (value) => {
  if (!value) return '₦0.00';
  return `₦${(value / 1000).toFixed(1)}K`;
};
</script>

<style scoped>
.metric-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-top: 4px solid;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.card-badge {
  background: #667eea;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
}

.card-body {
  padding: 20px;
  flex: 1;
}

.metric-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  font-size: 14px;
}

.metric-row:last-child {
  margin-bottom: 0;
}

.label {
  color: #666;
  font-weight: 500;
}

.value {
  color: #333;
  font-weight: 700;
}

.card-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.view-btn {
  width: 100%;
  padding: 10px 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 14px;
}

.view-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

.view-btn:active {
  transform: scale(0.98);
}
</style>
